import useElectricityMeter from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/useElectricityMeter'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

const MissingEnedisNeededFields = () => {
  const { t, shouldHideMissingFieldsNotification } = useElectricityMeter({ type: 'client' })

  return (
    <SDNotification
      type='warning'
      hidden={shouldHideMissingFieldsNotification}
      primaryText={t('subscriptionForm:pdl_module.enedis_authorization.warning_missing_data_enedis_auth_v2')}
    />
  )
}

export default MissingEnedisNeededFields
